export default __webpack_public_path__ + "50dd71fdd47de4e8fb1db6567b943071.png";